/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditspartextra2Inputs */

const en_creditspartextra2 = /** @type {(inputs: Creditspartextra2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra`)
};

const de_creditspartextra2 = /** @type {(inputs: Creditspartextra2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra`)
};

/**
* | output |
* | --- |
* | "Extra" |
*
* @param {Creditspartextra2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditspartextra2 = /** @type {((inputs?: Creditspartextra2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditspartextra2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditspartextra2(inputs)
	return de_creditspartextra2(inputs)
});
export { creditspartextra2 as "creditsPartExtra" }